import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";
import type { IOrderDelete } from "@app/dashboard/types/innerLayout/orders";

export const deleteOrder = ({
  orderId
}: IOrderDelete) => {

  return axiosPrivate.delete(`/dashboard/api/v1/orders/${orderId}/delete`);
};